<template>
  <div class="faq">
    <Hero
      :backImg="require('../assets/img/faq/hero.jpg')"
      alt=""
      :backImgSp="require('../assets/img/faq/hero_sp.jpg')"
      title="よくあるご質問"
      text=""
    />
    <div class="contents">
      <section class="category">
        <div class="title">
          <h3>採用・選考について</h3>
        </div>
        <div class="faq_list">
          <FaqLine
              question="クレハの求める人物像について教えてください。"
              answer="クレハは、「独自技術でスペシャリティを追求し、未来を拓く社会貢献企業」として、厳しい事業環境の中で競争に勝ち抜かなければなりません。そのために、主体的・自律的に物事に取り組む意欲のある方、失敗を恐れずに挑戦できる方、周りを巻き込みながら粘り強く実行できる方に来ていただきたいと考えています。"
          />
          <FaqLine
            question="ＯＢ・ＯＧ訪問はできますか？"
            answer="選考過程でご希望をお伺いし、当社の先輩社員とお会いいただく機会を設定いたします。"
          />
          <FaqLine
            question="研究所・工場見学はできますか？"
            answer="選考過程の中でご希望をお伺いし、研究所・工場を見学いただく機会を設定いたします。"
          />
          <FaqLine
            question="入社するまでに準備しておくことはありますか？"
            answer="特に指定の準備はありません。皆さんが在学中にすべきこと、学生時代にしかできないことに、しっかりと取り組んでいただくことが大切だと考えています。"
          />
        </div>
      </section>
      <section class="category">
        <div class="title">
          <h3>配属・異動・育成について</h3>
        </div>
        <div class="faq_list">
          <FaqLine
              question="研究・技術職種の社員が配属されるのはどのような部門ですか？"
              answer="研究・技術職種は、まずは研究開発、生産技術、プロセス開発を中心に、いわき地区の研究所、事業所や茨城地区の研究所、事業所に配属となります。"
          />
          <FaqLine
              question="企画・営業職種の社員が配属されるのはどのような部門ですか？"
              answer="企画・営業職種は、まずはいわき事業所の人事部門や生産企画部門に配属となることが多いです。その後、時期は人によってまちまちですが、多くの方が本社などの営業部門や間接部門に異動となっています。"
          />
          <FaqLine
            question="希望する職場に配属されますか？"
            answer="配属先は当社の事業計画に沿って決定します。事業領域が広いため、配属前に面談を行い、皆さんの希望を確認し、職務適性を踏まえて決定します。"
          />
          <FaqLine
            question="異動や転勤は定期的にありますか？"
            answer="当社の事業計画や本人の適性・希望、今後の育成の必要性などに応じて、異動や転勤を行っています。（2年に一度、今後の担当業務について自分の希望を会社に申告する「キャリア自己申告制度」を設けています。）"
          />
          <FaqLine
            question="理系出身者でも営業などの仕事に就くことはできますか？"
            answer="できます。当社では理系出身の社員が企画・営業などの職場でも活躍しています。"
          />
          <FaqLine
              question="学生時代の研究は企業で役立ちますか？"
              answer="学生時代の研究テーマが必ずしも企業での研究に直結するとは限りませんが、学生時代に修得した研究の進め方・考え方や研究手法、研究への姿勢・熱意は社会人になっても活かすことができます。企業にはたくさんの選択肢がありますので、学生時代の研究に固執することなく、幅広い視点を持って活躍いただければと思います。"
          />
          <FaqLine
              question="文系専攻なので化学の知識がないのですが、大丈夫ですか？"
              answer="問題ありません。業務で必要となる知識は社内研修や実際の業務を通して身につけることができます。ご自身の努力は必要ですが、多くの文系出身者が化学知識も学んで、営業でも活躍しています。"
          />
          <FaqLine
            question="海外で働くチャンスはありますか？"
            answer="海外での仕事には海外赴任と海外出張の2つがあります。<br>海外赴任は、当社の海外グループ会社などに出向し、現地で勤務していただきます。入社から数年以上経過した社員が赴任しています。<br>また、国内勤務の場合も、数日～数週間の単位で海外に出張していただくことがあります。入社1年目の新入社員でも出張する可能性がありますが、頻度や地域は仕事内容により異なります。"
          />

          <FaqLine
              question="入社時点での英語力はどれくらい必要ですか？"
              answer="入社時点での英語力は問いませんが、事業がグローバル化する中で、英語力は必要になってきます。クレハでは、オンライン英会話をはじめ、社内TOEIC試験など、英語研修を行っていますので、入社してからでも身につけることはできます。"
          />
          <FaqLine
              question="自己啓発について支援する制度はありますか？"
              answer="eラーニングや通信教育、社内外のセミナーなど、各人が興味のあるものを選択して、自主的に学べる応募型研修制度があります。また、海外留学制度や、社会人博士号取得支援制度もあり、学ぶ意欲の高い社員が制度を利用し、博士号を取得しています。"
          />
        </div>
      </section>
      <section class="category">
        <div class="title">
          <h3>支援制度・福利厚生について</h3>
        </div>
        <div class="faq_list">
          <FaqLine
            question="仕事や家庭の両立を支援する制度はありますか？"
            answer="出産や育児に関しては、産前産後休暇（産前6週間、産後8週間）や育児休業（お子さんが2歳に達する日まで）、短時間勤務（お子さんが小学校を卒業するまで）、育児休暇（お子さんが出生後6週以内に5日間まで）などの制度があります。また、介護に関しても、介護休業や短時間勤務などの制度があります。制度整備だけでなく、制度を利用しやすい職場環境に向けて取り組みを進めており、仕事と家庭の両立を支援しています。"
          />
          <FaqLine
            question="寮や社宅はありますか？"
            answer="社有や借上の社員寮、社宅があり、当社の規程に該当する方が入居できます。"
          />
<!--          <FaqLine-->
<!--            question="保養所はありますか？"-->
<!--            answer="社有の保養所が那須にあります。また、会社が加入している会員制福利厚生サービスにより、全国各地の各種保養施設やサービスを会員料金でご利用いただけます。そのほか、事業所によっては、グラウンドやテニスコートなどもあり、リフレッシュや健康増進のために活用されています。"-->
<!--          />-->
          <FaqLine
            question="クラブやサークル活動はありますか？"
            answer="事業所により異なりますが、野球、サッカー・フットサル、テニス、ジョギング、華道、茶道などのクラブやサークル活動が行われています。"
          />
<!--          <FaqLine-->
<!--            question="その他の福利厚生の制度にはどのようなものがありますか？"-->
<!--            answer="カフェテリアプラン（選択型福利厚生制度）、財形貯蓄や従業員持株会などの制度があります。カフェテリアプランとは、毎年各人に一定のポイントが付与され、会社が指定したメニューの中から希望するサービスを自分で選択して、ポイントの範囲内で支援を受けられる制度です。"-->
<!--          />-->
          <FaqLine
              question="その他の福利厚生制度にはどのようなものがありますか？"
              :answer="
              `
              カフェテリアプラン<sup>※</sup>、財形貯蓄、従業員持株会などの制度があります。また、事業所によっては、グラウンドやテニスコートなどもあり、リフレッシュや健康増進のために活用されています。その他、全国各地の保養施設や、グルメ・レジャーなどを会員料金で利用できるサービスにも加入しています。
                <br />
                <span style='font-size: 15px; font-weight: normal; text-indent: 0; margin-left: 0'>
                ※毎年各人に一定のポイントが付与され、会社が指定したメニューの中から希望するサービスを自分で選択して、ポイントの範囲内で支援を受けられる制度。
                </span>
              `
              "
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import FaqLine from '@/components/faq/FaqLine.vue';
export default {
  name: 'info',
  components: {
    Hero,
    FaqLine,
  },
};
</script>

<style scoped lang="scss">
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0;
  @media print, screen and (max-width: 767px) {
    padding: 50px 0 100px 0;
  }
}
.category + .category {
  .title {
    margin-top: 100px;
    @media print, screen and (max-width: 767px) {
      margin-top: 50px;
    }
  }
}
.title {
  font-size: 30px;
  color: #00797f;
  text-align: center;
  @media print, screen and (max-width: 767px) {
    font-size: 20px;
  }
  h3 {
    display: inline-block;
    position: relative;
    padding-bottom: 20px;
    &:before {
      content: '';
      width: 50%;
      border-top: 10px solid #00797f;
      height: 1px;
      display: block;
      position: absolute;
      bottom: 0;
    }
    &:after {
      content: '';
      width: 50%;
      border-top: 10px solid #3fae00;
      height: 1px;
      display: block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}
.faq_list {
  border-top: 2px solid #00797f;
  margin-top: 50px;
  @media print, screen and (max-width: 767px) {
    margin-top: 20px;
  }
}

.supplement{
  font-size: 15px;
  font-weight: normal;
  text-indent: 0;
  margin-left: 0;
}

</style>
